<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="handleBind">绑定服务商</a-button>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button icon="sync" @click="apiEnterpriseQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="企业查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">企业名称：</div>
						<a-input v-model="query.enterpriseName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">企业编码：</div>
						<a-input v-model="query.enterpriseCode" style="width: 100%;" placeholder="请输入完整的企业编码" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiEnterpriseQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="enterpriseId" :loading="tableLoading" :pagination="false">
				<span slot="enterpriseName" slot-scope="enterpriseName">
					<a-button type="link" @click="edit(enterpriseName)" >{{enterpriseName.enterpriseName}}</a-button>
				</span>
	
				
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="企业名称" has-feedback prop="enterpriseName">
							<a-input v-model="addForm.enterpriseName" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="企业编码" has-feedback prop="enterpriseCode">
							<a-input v-model="addForm.enterpriseCode" />
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<!-- <div >
						<a-form-model-item label="对应服务商" has-feedback prop="facilitatorId">
							<a-checkbox-group :options="facilitatorList"   v-model="addForm.facilitatorId"/>
						</a-form-model-item>
					</div> -->
				
					<div class="qa-table-item-3">
						<a-form-model-item label="企业电话" has-feedback prop="enterprisePhone">
							<a-input v-model="addForm.enterprisePhone" />
						</a-form-model-item>
						<a-form-model-item label="开户行账号" has-feedback prop="enterpriseAccount">
							<a-input v-model="addForm.enterpriseAccount" />
						</a-form-model-item>
						<a-form-model-item label="企业邮箱" has-feedback prop="enterpriseEmail">
							<a-input v-model="addForm.enterpriseEmail" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="企业地址" has-feedback prop="enterpriseAddress">
							<a-input v-model="addForm.enterpriseAddress" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="enterpriseRemarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.enterpriseRemarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="企业名称" has-feedback prop="enterpriseName">
							<a-input v-model="editForm.enterpriseName" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="企业编码" has-feedback prop="enterpriseCode">
							<a-input v-model="editForm.enterpriseCode" />
						</a-form-model-item>
						<a-form-model-item ></a-form-model-item>
						<a-form-model-item ></a-form-model-item>
					</div>
					<!-- <div >
						<a-form-model-item label="对应服务商" has-feedback prop="facilitatorId">
							<a-checkbox-group :options="facilitatorList"  v-model="editForm.facilitatorId" />
						</a-form-model-item>
					</div> -->
					
					<div class="qa-table-item-3">
						<a-form-model-item label="企业电话" has-feedback prop="enterprisePhone">
							<a-input v-model="editForm.enterprisePhone" />
						</a-form-model-item>
						<a-form-model-item label="开户行账号" has-feedback prop="enterpriseAccount">
							<a-input v-model="editForm.enterpriseAccount" />
						</a-form-model-item>
						<a-form-model-item label="企业邮箱" has-feedback prop="enterpriseEmail">
							<a-input v-model="editForm.enterpriseEmail" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="企业地址" has-feedback prop="enterpriseAddress">
							<a-input v-model="editForm.enterpriseAddress" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="enterpriseRemarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.enterpriseRemarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
					
				</a-form-model>
			</div>
			
		</a-modal>
		<a-drawer class="qa-modal" :title="bindTitle" width="50%" :visible="bindVisible"  @close="bindVisible=false" :footer="null" :maskClosable="false" :keyboard="false">
			<enterprise-facilitator style="width: 100%;" v-if="bindVisible" :enterpriseId = "enterpriseId"></enterprise-facilitator>
		</a-drawer>
	</div>
</template>

<script>
	import EnterpriseFacilitator from './EnterpriseFacilitator.vue'
	export default {
		components:{
			EnterpriseFacilitator
		},
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				enterpriseId:undefined,
				bindVisible:false,
				bindTitle:'绑定服务商',
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					enterpriseName: '',
					enterpriseCode: '',
				},
				tableData: [],
				tableColumns: [{
						title: '企业ID',
						dataIndex: 'enterpriseId',
						key: 'enterpriseId',
						align: 'center'
					},
					{
						title: '编码',
						dataIndex: 'enterpriseCode',
						key: 'enterpriseCode',
						align: 'center',
						
					},
					{
						title: '企业名称',
						key: 'enterpriseName',
						align: 'center',
						scopedSlots: {
							customRender: 'enterpriseName'
						}
					},
					{
						title: '企业电话',
						dataIndex: 'enterprisePhone',
						key: 'enterprisePhone',
						align: 'center',
					},
					{
						title: '邮箱',
						dataIndex: 'enterpriseEmail',
						key: 'enterpriseEmail',
						align: 'center',
					},
					{
						title: '企业地址',
						dataIndex: 'enterpriseAddress',
						key: 'enterpriseAddress',
						align: 'center',
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					enterpriseName: '',
					enterpriseCode: '',
					enterprisePhone: '',
					enterpriseAccount: '',
					enterpriseEmail: '',
					enterpriseAddress: '',
					enterpriseRemarks: '',
				},
				addRules: {
					enterpriseName: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
					enterpriseCode: [{ required: true, message: '企业编码不能为空', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					enterpriseId: '',
					enterpriseName: '',
					enterpriseCode: '',
					enterprisePhone: '',
					enterpriseAccount: '',
					enterpriseEmail: '',
					enterpriseAddress: '',
					enterpriseRemarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,this.query);
				if (res.code == 200) {
					for(let i=0; i<res.data.length; i++){
						this.facilitatorList[i] = {label: res.data[i].facilitatorName, value:res.data[i].facilitatorId}
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiEnterpriseQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiEnterpriseQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiEnterpriseQueryList()
			},
			//添加弹窗事件-开始
			tableAdd() {
				this.addVisible = true
			},
			async apiEnterpriseAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiEnterpriseQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiEnterpriseAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				items.facilitatorId = JSON.parse(items.facilitatorId)
				this.editForm = items
				this.editVisible = true
			},
			async apiEnterpriseEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiEnterpriseQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiEnterpriseEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			editCheckboxFacilitatorId(checkedValues) {
				console.log(checkedValues);
			},
			//修改弹窗事件-结束
			

			tableEdit() {
				if(this.tableSelectedRows.enterpriseId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			handleBind(){
				if(this.tableSelectedRows.enterpriseId > 0) {
					this.bindFacilitator(this.tableSelectedRows) 
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			bindFacilitator(item){
				this.enterpriseId = item.enterpriseId
				this.bindTitle = '[' + item.enterpriseName + ']服务商列表'
				this.bindVisible = true
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			// this.apiFacilitatorList()
			this.apiEnterpriseQueryList()
		}
	};
</script>

<style scoped>
	
	
</style>
